import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const hotspots = [
  {
    id: 1,
    top: "62%",
    left: "58%",
    label: "Hospital São Vicente de Paulo",
    classe: "pulse-red",
  },
  { id: 2, top: "51.5%", left: "52%", label: "Zaffari", classe: "pulse-blue" },
  {
    id: 3,
    top: "56%",
    left: "75%",
    label: "Praça Tamandaré",
    classe: "pulse-green",
  },
  {
    id: 4,
    top: "31%",
    left: "68%",
    label: "Bella Cittá Shopping Center",
    classe: "pulse-blue",
  },
  { id: 5, top: "21%", left: "59%", label: "Catedral", classe: "pulse-brown" },
  {
    id: 6,
    top: "71.5%",
    left: "44.5%",
    label: "Centro de Esporte e Lazer Fredolino Chimango",
    classe: "pulse-green",
  },
  {
    id: 7,
    top: "47%",
    left: "91%",
    label: "Colégio Notre Dame",
    classe: "pulse-yellow",
  },
  {
    id: 8,
    top: "39%",
    left: "34%",
    label: "Hospital Prontoclínica",
    classe: "pulse-red",
  },
  {
    id: 9,
    top: "19%",
    left: "20%",
    label: "Hospital de Clínicas",
    classe: "pulse-red",
  },
  {
    id: 10,
    top: "18%",
    left: "12%",
    label: "Praça Antonino Xavier",
    classe: "pulse-green",
  },
  {
    id: 11,
    top: "28%",
    left: "30%",
    label: "Colégio Marista Conceição",
    classe: "pulse-yellow",
  },
  {
    id: 12,
    top: "20%",
    left: "36%",
    label: "Praça Tochetto",
    classe: "pulse-green",
  },
  { id: "W", top: "28%", left: "59%", label: "Wiser", classe: "pulse-wiser" },
  {
    id: "F",
    top: "38%",
    left: "66%",
    label: "Farmácia São João",
    classe: "pulse-red",
  },
];

function Location() {
  return (
    <section className="tc-location-style">
      <div className="container">
        <div className="row align-items-center position-relative">
          <div className="col-lg-6 znd2 ms-100 mt-40">
            <h2 className="fsz-65 title-location js-splittext-lines">
              <div className="color-gray">
                <span className="color-brown2 text-uppercase font-palast-regular">
                  Localização
                </span>
              </div>
            </h2>
            <p
              className="color-gray mt-4 wow zoomIn slow ltspc-2 lh-1"
              data-wow-delay="0.2s"
            >
              <span className="fsz-16">
                Posicionado estrategicamente no coração de Passo Fundo,
                <strong className="fsz-21 font-palast-bold-italic lh-1 ltspc-1">
                  {" "}
                  em um dos cruzamentos mais importantes da cidade,{" "}
                </strong>
                entre as ruas Uruguai, Quinze de Novembro e 7 de Setembro. Este
                empreendimento coloca você no epicentro da praticidade, onde
                cada detalhe foi pensado para otimizar o seu tempo e elevar sua
                qualidade de vida.
              </span>
            </p>
          </div>

          <div className="col-lg-8 position-absolute col-image wow zoomIn slow">
            <LazyLoadImage
              src="/home_borin/assets/images/location/loc.webp"
              alt="mapa da localização da Wiser"
              className="location-partial-img ms-20"
              effect="blur" 
              width={"100%"}
              height={"100%"}
            />
            {hotspots.map((spot) => (
              <div
                key={spot.id}
                className={`hotspot ${spot.classe}`}
                style={{ top: spot.top, left: spot.left }}
              >
                <span className="pulse"></span>
                {spot.id === "W" ? (
                  <img
                    src="/home_borin/assets/images/location/wiser.webp"
                    alt="Wiser"
                    className="wiser-img"
                  />
                ) : (
                  spot.id
                )}
                <span className="tooltip">{spot.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Location;
